import { EnvName, EnvZodEnum } from '../environment';

export const determineEnv = (): EnvName => {
  const env = EnvZodEnum.safeParse(import.meta.env.VITE_ENV);
  if (!env.success) {
    return 'local';
  }
  return env.data;
};
